export default function scrollTo(scrollViewRef, ...props) {
    if (scrollViewRef.current) {
        const scrollViewNode = scrollViewRef.current?.getNode?.() ??
            scrollViewRef.current;
        scrollViewNode?.scrollTo(...props);
    }
}
